import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useApiMutation } from '../../apis/useApi';
// import SignupForm from './MembershipFormComponent';
import MembershipFormComponent from './MembershipFormComponent';
import Loader from '../loader/Loader';
import SubmitButton from '../../generic-components/button/FormButton';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomerMembership } from './CustomerMembershipResponse';

const MembershipFormPage = () => {
    const {
        control,
        register,
        watch,
        reset,
        setValue,
        formState: { errors: formErrors, touchedFields },
        handleSubmit,
        setError,
        clearErrors,
        getValues
    } = useForm({ mode: "all" });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const {
        taxonomyCategoryIds,
        taxonomySubCategoryIds,
        partnerId,
        parterToOfferId,
        categoryId
    } = useParams<{
        taxonomyCategoryIds: string;
        taxonomySubCategoryIds: string;
        partnerId: string;
        parterToOfferId: string;
        categoryId: string;
    }>();

    useEffect(() => {
        const timeout = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 1000);
        return () => clearTimeout(timeout);
    }, []);

    const scopeKey = 'BID Partner';
    const submitMemberShipForm = useApiMutation<CustomerMembership, {}>(
        `/o/c/bidleads/scopes/${encodeURIComponent(scopeKey)}`,
        'post',
        {
            onSuccess: (data: CustomerMembership) => {
                if (data?.id) {
                    setLoading(false);

                    navigate(
                        `/categories/${categoryId}/${taxonomyCategoryIds}/${taxonomySubCategoryIds}/${partnerId}/success-page/${parterToOfferId}`
                    );
                } else {
                    setLoading(false);
                    navigate(
                        `/categories/${categoryId}/${taxonomyCategoryIds}/${taxonomySubCategoryIds}/${partnerId}/error-page/${parterToOfferId}`
                    );
                }
            },
            onError: (error: any) => {
                setLoading(false);
                navigate(
                    `/categories/${categoryId}/${taxonomyCategoryIds}/${taxonomySubCategoryIds}/${partnerId}/error-page/${parterToOfferId}`
                );
            }
        }
    );

    const onSubmit = async (data: any, event: any) => {
        setLoading(true);
        event?.preventDefault();
        event?.stopPropagation();

        // Build payload for final membership submission
        const payload = {
            r_offerToLead_c_partnerOfferId: parterToOfferId,
            companyName: data?.companyName,
            customerName: data?.customerName,
            country: data?.country,
            city: data?.city,
            membershipNumber: data?.membershipNumber,
            industry: data?.customerIndustry,
            description: data?.description,
            phoneNumber: data?.mobileNumber,
            email: data?.emailAddress
        };

        try {
            submitMemberShipForm.mutate({
                data: payload,
                params: {}
            });
            reset();
        } catch (error) {
            console.error('check-membership error', error);
            setLoading(false);
            navigate(
                `/categories/${categoryId}/${taxonomyCategoryIds}/${taxonomySubCategoryIds}/${partnerId}/error-page/${parterToOfferId}`,
                {
                    state: {
                        message:
                            'Please register yourself for the membership for the Dubai Chamber.'
                    }
                } as any
            );
        }
    };

    return (
        <div style={{padding: '0 9rem'}}>
            <h1
                className="login-form-title"
                style={{
                    color: '#FFFFFF',
                    fontSize: '26px',
                    marginBottom: '0'
                }}
            >
                Membership Details
            </h1>
            <p
                className="login-form-text"
                style={{
                    color: '#FFFFFF',
                    fontSize: '16px',
                    marginBottom: '1 rem'
                }}
            >
                Please verify your details
            </p>
            <p
                className="login-form-text"
                style={{
                    color: '#FFFFFF',
                    fontSize: '16px',
                    marginBottom: '3rem'
                }}
            >
                Note: In case you don't remember your membership number please
                contact 'customercare@dubaichamber.com'.</p>
            <form
                onSubmit={handleSubmit(onSubmit)}
                autoComplete="off"
                className="roadshow"
                
            >
                {loading && <Loader />}
                <MembershipFormComponent
                    watch={watch}
                    reset={reset}
                    setValue={setValue}
                    control={control}
                    formErrors={formErrors}
                    touchedFields={touchedFields}
                    register={register}
                    setError={setError}
                    clearErrors={clearErrors}
                    getValues={getValues}
                />

                <div className="sign_button_conatiner button-cut mt-5 col-12">
                    <SubmitButton
                        label="Confirm"
                        disable={Boolean(Object.keys(formErrors).length > 0)}
                    />
                </div>
            </form>
        </div>
    );
};
export default MembershipFormPage;
